import { Box, Container } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { homePageTheme } from 'components/themes/theme';

export function HomePage() {
    return (
        <ThemeProvider theme={homePageTheme}>
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Container
                    maxWidth={false}
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        py: 4
                    }}
                >
                    {/* Blank homepage */}
                </Container>
            </Box>
        </ThemeProvider>
    );
}
